/**
 * https://www.sanity.io/docs/apis-and-sdks/image-urls#bhpyf4m0
 * @param url
 * @param preset
 */
export function useSanityImage(url?: string, preset: 'cover' | 'thumbnail' | 'hero' = 'cover'): string | undefined {
	const presets = {
		cover: '?auto=format&fit=max&w=1200&fm=webp',
		hero: '?auto=format&fit=max&w=800&fm=webp',
		thumbnail: '?auto=format&fit=max&w=600&fm=webp'
	};

	if (!url) return undefined;
	return url + presets[preset];
}
